import React from 'react';
import { useSttDicomHub } from '../hooks';

export default function SttDicomHubLink({ config }: { config: AppTypes.Config }) {
  useSttDicomHub(config);

  return <></>;
}
